
import React, { forwardRef } from "react";
import { useGoogleLogin,GoogleLogin  } from "@react-oauth/google";
import axios from "axios";
import { Grid, Button, Typography, Box } from "@mui/material";
import GoogleSignInImage from "../images/Google Sign In.png"


const GmailLogin = forwardRef(({ setUser }, loginRef) => {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log("tokenResponse", tokenResponse);
      try {
        const userInfo = await axios.get( 
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        console.log("User info data:", userInfo.data);
        setUser(userInfo.data);
        localStorage.setItem("userData",JSON.stringify(userInfo?.data))    
      } catch (error) {
        console.log("User Info Fetch Error:", error);
      }
    },

    onError: (err) => {
      console.log("Login Failed:", err);
    }
  });

  return (
   <Grid
      container
      alignItems="center"
      sx={{
        mt: 1,
        pl: { xs: 0, sm: 5, md: 25 }, // responsive spacing
        display: "flex",
        marginLeft:"5%",
        marginTop:"3%"

      }}
    >
      {/* Left Text */}
      <Typography
        sx={{
          mr: 1,
          fontSize: "16px",
          fontWeight: 600,
          fontFamily:"'OpenSans-Regular'"
          
        }}
      >
       Login with :
      </Typography>


        <Box
          ref={loginRef}       
          onClick={login}
          component="img"
          src={GoogleSignInImage}
          alt="Google Icon"
          sx={{
            width: "120px",
            height: "36px",
            color:"#fff",
            cursor:"pointer"

          }}
        />
    </Grid>
    
  );
});



export default GmailLogin;




// import React from 'react'
// import { GoogleLogin,useGoogleLogin } from 'react-google-login'
// import { GoogleLogin, GoogleOAuthProvider  } from '@react-oauth/google'
// import { useNavigate } from 'react-router-dom';

// const clientid="680112460794-1pf98be8jbjeaavanmvrup3popmdk2pd.apps.googleusercontent.com"; // for usersutdemo@gmail.com
// const clientid= "57083087783-fjd3uckol0tvaug0ccd1db3lbq5b5qi9.apps.googleusercontent.com"
// const clientId="540829784115-nke9rmeesdsmtkct2iie6mt7lrf580ff.apps.googleusercontent.com"
// function GmailLogin() {
// const navigate = useNavigate()
// const onSuccess=(resp)=>{
//     console.log("success")
//     console.log("login success of current user ", resp.googleId)
//     // if(resp.googleId!=null){navigate("/test")}
// }

// const onFailure=(resp)=>{
//     console.log("login failed of current user ", resp)
// }

//   return (
//     <div>
// <GoogleLogin
// clientId={clientid}
// buttonText="Login button"
// onSuccess={onSuccess}
// onFailure={onFailure}
// cookiePolicy={"single_host_origin"}
// isSignedIn={true}
// style={{marginLeft:"200px", color:"red", width:"200px"}}


//   //  <span> Login with Google</span>

// />
//     </div>
//   )
// }

// export default GmailLogin

// import React from 'react'
// import { useGoogleLogin} from 'react-google-login'; 
//   import { refreshTokenSetup}from '../utils/refreshToken'; 
// const clientId = 'YOUR_CLIENT_ID.apps.googleusercontent.com'; 
// My custom button return <button onClick=fsignIn1 className="button"› <img src="icons/google.svg"></img> <span className=“buttonText">Sign in with Google</span> </button> 1 

// import React from 'react'
// import { GoogleLogin,useGoogleLogin } from 'react-google-login'
// function GmailLogin({setUser}) { 

// const clientId="540829784115-nke9rmeesdsmtkct2iie6mt7lrf580ff.apps.googleusercontent.com"

// const onSuccess=(resp)=>{
//     console.log("success")
//     console.log("login success of current user", resp.googleId)
//     setUser(resp.data);  // <--- Save logged-in user
//     // if(resp.googleId!=null){navigate("/test")}
// }

// const onFailure=(resp)=>{
//     console.log("login failed of current user ", resp)
// }


// const { signIn}  = useGoogleLogin({
//     onSuccess,
//     onFailure,
//     clientId,
//     isSignedIn: true, 
//     accessType: 'offline'
//   }) 

  
//  return (
//     <div style={{ display: "flex", alignItems: "center", marginLeft: "250px" }}>
//       <span style={{ marginRight: "10px", fontSize: "16px", fontWeight: "600",fontFamily:"'OpenSans-Regular'" }}>
//       Login with :
//       </span>
//       <button
//         onClick={() => signIn()}
//         // onClick={signIn}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           backgroundColor: "#4285F4",
//           color: "white",
//           border: "none",
//           padding: "8px 15px",
//           borderRadius: "4px",
//           cursor: "pointer",
//           fontSize: "16px",
//           fontWeight: "500",
//         }}
//       >
//         <img
//           src="https://developers.google.com/identity/images/g-logo.png"
//           alt="Google"
//           style={{ width: "20px", marginRight: "10px", background: "white", padding: "2px", borderRadius: "2px" }}
//         />
//         Sign in
//       </button>
//     </div>
//   );
// }     

// export default GmailLogin; 

